import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useUuidLayoutContext } from "hooks/routerHooks";

import { ClimateEffectsPageLoader } from "components/loader/ClimateEffectsPageLoader";
import { ClimateEffectsPageSkeleton } from "components/skeletons/ClimateEffectsPageSkeleton";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";

export function ClimateEffectsPage() {
  const { mapRef, footerRef, uuid, mapOverlayContainer } =
    useUuidLayoutContext();

  return (
    <ErrorBoundary
      FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
    >
      <Suspense
        fallback={
          <ClimateEffectsPageSkeleton
            footerRef={footerRef}
            mapOverlayContainer={mapOverlayContainer}
          />
        }
      >
        <ClimateEffectsPageLoader
          uuid={uuid}
          mapRef={mapRef}
          footerRef={footerRef}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
